import React, { useState } from "react";

const ChannelDetails = ({ onClose, channelDetails }) => {
  const [copiedActivityKey, setCopiedActivityKey] = useState(false);

  const handleActivityKeyCopy = () => {
    const activityKey = channelDetails?.activityKey || "";
    if (activityKey) {
      navigator.clipboard.writeText(activityKey);
      setCopiedActivityKey(true);
      setTimeout(() => setCopiedActivityKey(false), 1500);
    }
  };

  const getChannelIcon = (channel) => {
    switch (channel?.toLowerCase()) {
      case "email":
        return "📧";
      case "push":
        return "🔔";
      case "sms":
        return "💬";
      default:
        return "📬";
    }
  };

  const getStatusIndicator = (status) => {
    if (
      status?.toLowerCase() === "enabled" ||
      status?.toLowerCase() === "active"
    ) {
      return { class: "channel-details__status--enabled", label: "Enabled" };
    }
    return { class: "channel-details__status--disabled", label: "Disabled" };
  };

  const statusIndicator = getStatusIndicator(channelDetails?.status);

  return (
    <div className="right-modal channel-details-modal">
      {/* Modal Header */}
      <div className="channel-details__header">
        <h2 className="channel-details__title">Channel Details</h2>
        <button onClick={onClose} className="channel-details__close-btn">
          ✕
        </button>
      </div>

      {/* Modal Body */}
      <div className="channel-details__body">
        {/* Channel Configuration Section */}
        <div className="channel-details__section">
          <h3 className="channel-details__section-title">
            CHANNEL CONFIGURATION
          </h3>

          {/* Activity Key */}
          <div className="channel-details__field">
            <label className="channel-details__label">Activity Key</label>
            <button
              onClick={handleActivityKeyCopy}
              className="channel-details__activity-key"
              title="Click to copy"
            >
              <span>{channelDetails?.activityKey || "-"}</span>
              {copiedActivityKey ? (
                <span className="channel-details__activity-key-icon">✓</span>
              ) : (
                <span className="channel-details__activity-key-icon">📋</span>
              )}
            </button>
          </div>

          {/* Channel & Type Row */}
          <div className="channel-details__two-column">
            <div className="channel-details__field">
              <label className="channel-details__label">Channel</label>
              <div className="channel-details__badge">
                <span className="channel-details__badge-icon">
                  {getChannelIcon(channelDetails?.channel)}
                </span>
                <span>{channelDetails?.channel || "-"}</span>
              </div>
            </div>

            <div className="channel-details__field">
              <label className="channel-details__label">
                Notification Type
              </label>
              <span className="channel-details__badge channel-details__badge--type">
                {channelDetails?.type || "-"}
              </span>
            </div>
          </div>

          {/* Status */}
          <div className="channel-details__field">
            <label className="channel-details__label">Status</label>
            <div className={`channel-details__status ${statusIndicator.class}`}>
              <span className="channel-details__status-dot" />
              <span className="channel-details__status-text">
                {statusIndicator.label}
              </span>
            </div>
          </div>

          {/* Description */}
          <div className="channel-details__field">
            <label className="channel-details__label">Description</label>
            <p className="channel-details__description">
              {channelDetails?.description || "-"}
            </p>
          </div>

          {/* Short ID */}
          <div className="channel-details__field">
            <label className="channel-details__label">Short ID</label>
            <p className="channel-details__short-id">
              {channelDetails?._original?.shortId ||
                channelDetails?.activityKey?.substring(0, 20) ||
                "-"}
            </p>
          </div>
        </div>

        {/* Performance Section */}
        <div className="channel-details__section">
          <h3 className="channel-details__section-title">
            PERFORMANCE (LAST 7 DAYS)
          </h3>

          <div className="channel-details__metrics">
            {/* Total Sent */}
            <div className="channel-details__metric-card">
              <p className="channel-details__metric-label">TOTAL SENT</p>
              <p className="channel-details__metric-value channel-details__metric-value--success">
                {(channelDetails?._original?.totalSent || 0).toLocaleString()}
              </p>
            </div>

            {/* Delivered */}
            <div className="channel-details__metric-card">
              <p className="channel-details__metric-label">DELIVERED</p>
              <p className="channel-details__metric-value channel-details__metric-value--success">
                {(channelDetails?._original?.delivered || 0).toLocaleString()}
              </p>
            </div>

            {/* Failed */}
            <div className="channel-details__metric-card">
              <p className="channel-details__metric-label">FAILED</p>
              <p className="channel-details__metric-value channel-details__metric-value--danger">
                {(channelDetails?._original?.failed || 0).toLocaleString()}
              </p>
            </div>

            {/* Delivery Rate */}
            <div className="channel-details__metric-card">
              <p className="channel-details__metric-label">DELIVERY RATE</p>
              <p className="channel-details__metric-value channel-details__metric-value--success">
                {((channelDetails?._original?.deliveryRate || 0) * 100).toFixed(
                  1,
                )}
                %
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Footer */}
      <div className="channel-details__footer">
        <button onClick={onClose} className="channel-details__close-footer-btn">
          Close
        </button>
      </div>
    </div>
  );
};

export default ChannelDetails;
